var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';
import Add from "../Add.vue";
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = document.documentElement.clientHeight - 240;
        return _this;
    }
    default_1.prototype.selectionChange = function () { };
    default_1.prototype.toEdit = function (row) {
        this.$emit("add-tab", {
            component: Add,
            title: '编辑报价单',
            showExist: true,
            name: 'add-quotedprice' + row.order_id,
            cprops: {
                priceType: row.order_type,
                orderid: row.order_id
            }
        });
    };
    default_1.prototype.toDetail = function (row) {
        this.$emit("to-detail", row);
    };
    __decorate([
        Prop({
            required: true,
            type: Array
        })
    ], default_1.prototype, "data", void 0);
    __decorate([
        Emit('selection-change')
    ], default_1.prototype, "selectionChange", null);
    default_1 = __decorate([
        Component
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
